const buildPowerWordQuestionsArray = (
  powerWordQuestions,
  answeredQuestionIds,
) => {
  const answeredQuestions = [];
  const unansweredQuestions = [];

  powerWordQuestions.forEach((question) => {
    const answerMatch = question?.options.find((option) =>
      answeredQuestionIds?.includes(option.id),
    );
    answerMatch
      ? answeredQuestions.push(question)
      : unansweredQuestions.push(question);
  });

  return [answeredQuestions, unansweredQuestions];
};

/**
 * The answered questions will return in display_order order.
 * This function sorts the answered questions to match the order of the answeredQuestionIds
 * since they were completed in a randomized order
 *
 * @param {array} answeredQuestionIds
 * @param {object} answeredQuestions
 * @return {array} - An array of answered questions sorted by answeredQuestionIds
 */
const sortAnsweredQuestions = (answeredQuestionIds, answeredQuestions) => {
  return (
    answeredQuestionIds?.map((id) => {
      return answeredQuestions.find((question) =>
        question?.options?.find((option) => option.id === id),
      );
    }) || answeredQuestions
  );
};

/**
 * The vocab activity differs from the typical quiz workflow in that it grades questions in piecemeal one at a time.
 * Effectively, in order to prevent student misbehaviour, question order within the power words activity is randomized.
 * In the case where a student stops taking a quiz and then restarts later, the code continues
 * to randomly select from unanswered questions until the activity is complete.
 *
 * @return {array} - An array of questions starting with student answered questions followed by unanswered questions shuffled.
 */
const shufflePowerWordQuestions = (
  powerWordQuestions,
  studentAnswerResponses,
) => {
  const answeredQuestionIds = studentAnswerResponses?.map(
    (question) => question?.answer_choice?.content_id,
  );
  const [answeredQuestions, unansweredQuestions] = buildPowerWordQuestionsArray(
    powerWordQuestions,
    answeredQuestionIds,
  );
  const sortedAnsweredQuestions = sortAnsweredQuestions(
    answeredQuestionIds,
    answeredQuestions,
  );
  const randomizedUnansweredQuestions = [...unansweredQuestions]?.sort(
    () => Math.random() - 0.5,
  );
  return [...sortedAnsweredQuestions, ...randomizedUnansweredQuestions];
};
export default shufflePowerWordQuestions;
